<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Variables</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Variables</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="card">
      <div class="card-body">
        <h5 class="font-weight-bold">Form</h5>
        <p>Fill in the form below to change the Auto Logout and Auto Disabled variables.</p>

          <label class="font-weight-bold">Auto Logout</label>

          <div class="d-flex flex-row">
            
            <div style="width: 40%">
              <input class="form-control" type="number" v-model="data[0].value" />
            </div>
            
            <div class="col-3">
              <select v-model="data[0].unit" class="form-control">
                <option v-for="unit in updated_units" :value="unit.key">{{ unit.value }}</option>
              </select>
            </div>
          </div>

          <hr />

          <label class="font-weight-bold">Auto Disabled</label>
          <div class="d-flex flex-row mb-5">
            
            <div style="width: 40%">
              <input class="form-control" type="number" v-model="data[1].value" />
            </div>
            
            <div class="col-3">
              <select v-model="data[1].unit" class="form-control">
                <option v-for="unit in updated_units" v-show="unit.value != 'Hours'" :value="unit.key">{{ unit.value }}</option>
              </select>
            </div>
          </div>


          <div class="d-flex flex-row justify-content-between mb-4">
            
            <div class="col-2">
              <label class="font-weight-bold">Reminder 1</label>
              <input type="number" class="form-control" v-model="data[2].value" />
            </div>
            <div class="d-flex flex-column justify-content-end col-2">
              <select class="form-control" v-model="data[2].unit">
                <option v-for="unit in updated_units" v-show="unit.value != 'Hours'" :value="unit.key">{{ unit.value }}</option>
              </select>
            </div>
            <div class="col-2">
              <label class="font-weight-bold">Reminder 2</label>
              <input type="number" class="form-control" v-model="data[3].value" />
            </div>
            <div class="d-flex flex-column justify-content-end col-2">
              <select class="form-control" v-model="data[3].unit">
                <option v-for="unit in updated_units" v-show="unit.value != 'Hours'" :value="unit.key">{{ unit.value }}</option>
              </select>
            </div>
            <div class="col-2">
              <label class="font-weight-bold">Reminder 3</label>
              <input type="number" class="form-control" v-model="data[4].value" />
            </div>
            <div class="d-flex flex-column justify-content-end col-2">
              <select class="form-control" v-model="data[4].unit">
                <option v-for="unit in updated_units" v-show="unit.value != 'Hours'" :value="unit.key">{{ unit.value }}</option>
              </select>
            </div>
          </div>

          <div>
            <span><b>Note:</b></span> <br>
            <b>User last logged out date:</b> 1st January 2024 <br><br>

            <b>Auto disable account:</b> 6 Months <span style="color:red">(Account will be disabled on 1st July 2024)</span> <br>
            <b>Reminder 1:</b> 3 Months <b><u>before</u></b> disabled <span style="color:red">(Notification will be sent on 1st April 2024)</span> <br>
            <b>Reminder 2:</b> 2 Months <b><u>before</u></b> disabled <span style="color:red">(Notification will be sent on 1st May 2024)</span> <br>
            <b>Reminder 3:</b> 1 Months <b><u>before</u></b> disabled <span style="color:red">(Notification will be sent on 1st June 2024)</span> <br>
          </div>

          <div class="text-center mt-4">
            <button class="btn btn-success" @click="submit()">Update</button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRequest, patchRequest } from "@/services/RequestService";

export default {
  name: "customers",
  components: {
  },

  data() {
    return {
      data: [],
      units: {},
      updated_units: []
    };
  },

  methods: {
    async submit() {
      try {
        let res = await patchRequest('/durations', {durations: this.data});

        if(res.data.success) {
          return swal({
            icon: 'success',
            text: res.data.message
          })
        }
      } catch (e) {
        console.log(e)
        return false;
      }
    },

    async loadData() {
      this._api = `/durations`;

      try {
        let res = await getRequest(this._api);
        
        res.data.data.forEach(item => {
          let dataItem = ({
            id: item.id,
            type: this.formatType(item.type),
            value: parseInt(item.value),
            unit: this.formatUnit(item.unit),
            created_at: item.created_at,
            updated_at: item.updated_at,
          });

          this.data.push(dataItem);
        });

      } catch (e) {
        console.log(e)
      }
    },

    async loadUnit() {

      try {
        let res = await getRequest(`/durations/create`);
        
        this.units = res.data.data.units;

        Object.entries(this.units).forEach(([key, value]) => {
          console.log(`Key: ${key}, Value: ${value}`);
          this.updated_units.push({key: key, value: value})
        });
      } catch (e) {
        console.log(e)
      }
    },

    formatUnit(str) {
      switch(str) {
        case "Hours":
          return 1;
        case "Days":
          return 2;
        case "Months":
          return 3;
        case "Years":
          return 4;
      }
    },

    formatType(str) {
      switch(str) {
        case "Logout":
          return 1;
        case "Disable":
          return 2;
        case "Reminder":
          return 3;
      }
    }
  },


  async created() {
    await this.loadUnit();
    await this.loadData();
  }
};
</script>
